import { z } from 'zod';
import { CateringEventFormatModelSchema } from 'entities/catering-event-format';
import { GetCateringEventFormatBySlugApiResponseSchema } from '../store';

export const createCateringEventFormatFromGetCateringEventFormatBySlugApiResponse = (
    (response: z.infer< typeof GetCateringEventFormatBySlugApiResponseSchema>) => (
        CateringEventFormatModelSchema.parse({
            uid: response.data?.[0].slug,
            name: response.data?.[0].name,
            description: response.data?.[0].description,
            image: response.data?.[0].image && ({
                url: response.data?.[0].image.url,
            }),
            category: response.data?.[0].category && ({
                uid: response.data?.[0].category.slug,
                name: response.data?.[0].category.name,
                slug: response.data?.[0].category.slug,
            }),
            slug: response.data?.[0].slug,
        })
    )
);
